module.exports = __webpack_public_path__ + "static/media/tab.2b385383.svg";